
export enum SettingId {
	ClientId = 'clientId',
	BearerToken = 'bearerToken',
	IsTrainingMode = 'isTrainingMode',
	ForceDevRenderer = 'forceDevRenderer',
	// actually, storing this as a setting causes web desktop to totally fail
	// upon refresh.  no good!
	// SimulateOffline = 'simulateOffline',
	ShowDebugInfo = 'showDebugInfo',
}

export interface RenderSliceSettings {
	[SettingId.ShowDebugInfo]: boolean
}
